module.exports = __webpack_public_path__ + "static/media/qingjming.a701ec4f.png";